import { CancelAppointmentBody, RequestAppointmentBody } from "@medical-software-australia/fd-types/dist-types/external/automed";
import { get, post, put } from "../lib/api";
import {
  Clinic as UIClinic,
  Patient as UIPatient,
  PatientAppointment as UIPatientAppointment,
  PatientStatus as UIPatientStatus
} from "../models";
import { PatientStatusSchema } from "../models/patientschema";

export const getPatients = async (): Promise<UIPatient> => {
  return getPatientsV2();
}


export const getPatientsV2 = async (): Promise<UIPatient> => {
  try {
    const response: any = await get("patients");
    // console.log(response);
    const result: UIPatient = {
      id: response.patient_id,
      first_name: response.first_name,
      last_name: response.last_name
    };
    return result;
  } catch (error) {
    //console.log(error); // For debug
    throw Error("Failed to get Patient");
  }
};



export const getPatientStatus = async (patient_id: string): Promise<UIPatientStatus> => {
  return getPatientStatusV2(patient_id);
}


export const getPatientStatusV2 = async (patient_id: string): Promise<UIPatientStatus> => {
    try {
      const response: any = await get(`patients/status?patient_id=${patient_id}`);
      // console.log(response);
       PatientStatusSchema.parse(response); 
       return response as UIPatientStatus;
 
    } catch (error) {
      console.log(error); // For debug
      throw Error("Failed to get Patient Status");
    }
  };


  export const getPatientAppointments = async (
    patient_id: string
  ): Promise<UIPatientAppointment[] | string> => {
    return getPatientAppointmentsV2(patient_id);
  }


export const getPatientAppointmentsV2 = async (
  patient_id: string
): Promise<UIPatientAppointment[] | string> => {
  try {
    const response: any = await get(
      `/patients/appointments?patient_id=${patient_id}`
    );
    // console.log(response);
    // return response;
    if (response?.status === "false") {
      return response.message;
    } else {
      const data: UIPatientAppointment[] = response as UIPatientAppointment[];
      return data;
    }
  } catch (error) {
    console.log(error); // For debug
    throw Error("Failed to get Patient Appointments");
  }
};


export const createAppointment = async(clinic:UIClinic, patient: UIPatient, appoinment: UIPatientAppointment ) => {
  return createAppointmentV2(clinic, patient, appoinment);
} 
 
export const createAppointmentV2 = async(clinic:UIClinic, patient: UIPatient, appoinment: UIPatientAppointment ) => {
  try {
    const body: RequestAppointmentBody = {
      clinic_group_crm: clinic.clinic_group_crm,
      date: appoinment.date,
      user_fk: clinic.id,
      location_id: clinic.location_id,
      doctor_id: appoinment.doctor_id,
      appointment_type_id: appoinment.appointment_type_id,
      time: appoinment.time,
      duration: appoinment.duration,
      patient_id: patient.id,
      patient_name: patient.last_name,
     
    }
    
    const response: any = await put(`patients/appointments/request`, body);
    //console.log(response);
     return response; 

  } catch (error) {
    console.log(error); // For debug
    throw Error("Failed to create an appointment");
  }
 

}

export const cancelBookedAppointment = async(clinic_id: string, appointment_id:string) => {
  try {
    const body = {
      clinic_id: clinic_id,
      appointment_id: appointment_id,
    }
    if (!clinic_id || !appointment_id) {
      throw Error("Clinic ID and Appointment ID are required to cancel an appointment");
    }
    
    const response: any = await post(`clinics/cancelappointment`, body);
    return response; 

  } catch (error) {
    console.log(error); // For debug
    throw Error("Failed to cancel an appointment");
  }
}

export const cancelAppointment = async(clinic:UIClinic, appointment_id:string) => {
  return cancelAppointmentV2(clinic, appointment_id);
}

export const cancelAppointmentV2 = async(clinic:UIClinic, appointment_id:string) => {
  try {
    const body: CancelAppointmentBody = {
      clinic_group_crm:  clinic.clinic_group_crm,
      user_fk: clinic.id,
      location_id: clinic.location_id,
      appointment_id: appointment_id,
    }
    
    const response: any = await put(`patients/appointments/cancel`, body);
    //console.log(response);
    return response; 

  } catch (error) {
    console.log(error); // For debug
    throw Error("Failed to cancel an appointment");
  }
}



export const sendFamilyMemberVerification = async(phone_number:string) => {
  try {
    const body = {
      phone_number: phone_number
    }
    // Modified post call to NOT include headers (headers are set in api.ts)
    const response: any = await post(`user/sendfamilymemberverification`, body);
    return response; 
  } catch (error) {
    console.log(error); // For debug
    throw Error("Failed to generate and send verification code");
  }
}